// @ts-nocheck
"use client";

import { useEffect } from "react";

export default function ClientScripts() {
  useEffect(() => {
    // All animation/interaction functions defined here

// ─── HERO CANVAS ─────────────────────────────────────
function initCanvas(){
  const canvas=document.getElementById('hc'),ctx=canvas.getContext('2d');
  let W,H,P=[];
  const resize=()=>{W=canvas.width=canvas.offsetWidth;H=canvas.height=canvas.offsetHeight;};
  resize();window.addEventListener('resize',()=>{resize();make();});
  const make=()=>{P=[];for(let i=0;i<52;i++)P.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.36,vy:(Math.random()-.5)*.36,r:Math.random()*1.2+.4,a:Math.random()*.28+.07});};
  make();
  let hmx=-999,hmy=-999;
  canvas.closest('.hero').addEventListener('mousemove',e=>{const rc=canvas.getBoundingClientRect();hmx=e.clientX-rc.left;hmy=e.clientY-rc.top;});
  (function draw(){
    ctx.clearRect(0,0,W,H);
    P.forEach(p=>{
      p.x+=p.vx;p.y+=p.vy;
      if(p.x<0||p.x>W)p.vx*=-1;if(p.y<0||p.y>H)p.vy*=-1;
      const dx=hmx-p.x,dy=hmy-p.y,d=Math.sqrt(dx*dx+dy*dy);
      if(d<160){p.vx+=dx/d*.015;p.vy+=dy/d*.015;}
      p.vx*=.994;p.vy*=.994;
    });
    for(let i=0;i<P.length;i++){
      for(let j=i+1;j<P.length;j++){
        const dx=P[i].x-P[j].x,dy=P[i].y-P[j].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<120){ctx.strokeStyle=`rgba(184,110,44,${(1-d/120)*.1})`;ctx.lineWidth=.7;ctx.beginPath();ctx.moveTo(P[i].x,P[i].y);ctx.lineTo(P[j].x,P[j].y);ctx.stroke();}
      }
      ctx.beginPath();ctx.arc(P[i].x,P[i].y,P[i].r,0,Math.PI*2);ctx.fillStyle=`rgba(184,110,44,${P[i].a})`;ctx.fill();
    }
    requestAnimationFrame(draw);
  })();
}

// ─── HERO LIVE DEMO ──────────────────────────────────
// The hero demo is now rendered in its final state via SSR (see Hero.tsx) —
// score is "72", bars have inline width styles, risk tags / fix / cite /
// doc-meta have `.show` baked in. The page is therefore visually complete
// on first paint, on browser-back, on bfcache restore, and even with JS off.
// No client-side animation is needed and any reset would fight the SSR.
function initDemo(){ /* intentionally a no-op — see comment above */ }

// ─── SCRAMBLE ────────────────────────────────────────
function initScramble(){
  const el=document.getElementById('sw');if(!el)return;
  const ch='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const fin='the World';
  function run(){
    let f=0;const m=18;
    (function s(){
      el.textContent=fin.split('').map((c,i)=>i<Math.floor(f/m*fin.length)?c:ch[Math.floor(Math.random()*ch.length)]).join('');
      f++;if(f<=m)requestAnimationFrame(s);else el.textContent=fin;
    })();
  }
  setTimeout(run,1800);setInterval(()=>setTimeout(run,100),5200);
}

// ─── NAV + SCROLL ────────────────────────────────────
function initNav(){
  const nav=document.getElementById('nav'),spf=document.getElementById('spf');
  window.addEventListener('scroll',()=>{
    nav.classList.toggle('scrolled',scrollY>20);
    const total=document.body.scrollHeight-innerHeight;
    if(total>0)spf.style.width=(scrollY/total*100)+'%';
  },{passive:true});
}

// ─── MARQUEE ─────────────────────────────────────────
function initMarquee(){
  // Legal Research, Tax Intelligence, Court Research and Citation Graph left
  // this list 2026-09-18 — all four are India-only surfaces that 404 on this
  // product; the September work layer took their places.
  const items=['Contract Review','Meeting Minutes','AI Redlining','Regulatory Compliance','Tasks','Governing Law','Compliance Filings','Workflow Agents','Contract Lifecycle','Legal Health Score','NDA Analysis','Founder Agreements','Employment Contracts','Vendor Review','IP Protection','Risk Scoring'];
  const t=document.getElementById('mtrack');
  if(t)t.innerHTML=[...items,...items].map(i=>`<span class="mi">${i}</span>`).join('');
}

// ─── STICKY STORY ────────────────────────────────────
function initStickyStory(){
  const outer=document.getElementById('story');
  if(!outer)return;
  const frames=document.querySelectorAll('.sf');
  const docs=document.querySelectorAll('.sdoc');
  const pips=document.querySelectorAll('.spip');
  const bgNum=document.getElementById('storyBgNum');
  const N=frames.length||4;
  let idx=0,timer=null,inView=false;
  function setFrame(i){
    idx=i;
    frames.forEach((f,k)=>f.classList.toggle('active',k===i));
    docs.forEach((d,k)=>d.classList.toggle('active',k===i));
    pips.forEach((p,k)=>p.classList.toggle('active',k===i));
    if(bgNum)bgNum.textContent=String(i+1).padStart(2,'0');
    if(i===2){setTimeout(()=>{document.getElementById('ann1')?.classList.add('show');},400);setTimeout(()=>{document.getElementById('ann2')?.classList.add('show');},700);}
    else{document.getElementById('ann1')?.classList.remove('show');document.getElementById('ann2')?.classList.remove('show');}
  }
  function start(){
    if(timer)return;
    timer=setInterval(()=>{ if(inView) setFrame((idx+1)%N); },3800);
  }
  function stop(){ if(timer){clearInterval(timer);timer=null;} }
  // Auto-advance frames only while the section is visible. Reset to frame 0
  // each time the user enters the section so the story starts from "Upload".
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(en=>{
      if(en.isIntersecting&&en.intersectionRatio>0.35){
        if(!inView){inView=true;setFrame(0);}
        start();
      } else if(!en.isIntersecting){
        inView=false;stop();
      }
    });
  },{threshold:[0,0.35,0.6]});
  io.observe(outer);
  // Clicking a pip jumps to that frame and pauses auto-advance briefly.
  pips.forEach((p,i)=>p.addEventListener('click',()=>{
    setFrame(i);stop();setTimeout(start,5000);
  }));
}

// ─── HORIZONTAL SCROLL ───────────────────────────────
function initEngines(){
  // Vio + Nexus side-by-side demo. CSS owns the 12s loop; we just toggle
  // the `.eng-playing` class via IntersectionObserver so the loop runs in
  // view and pauses out of view (saves CPU/battery on long pages).
  const sec=document.querySelector('.eng-sec');
  if(!sec)return;
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(en=>sec.classList.toggle('eng-playing',en.isIntersecting));
  },{threshold:0.2});
  io.observe(sec);
}

function initHScroll(){
  // Native horizontal scrolling: the viewport (.hs-vp) handles scroll itself
  // (touch/wheel/drag), and we just sync the progress dots to the card under
  // the left edge. Clicking a dot scrolls to that card.
  const vp=document.querySelector('.hs-vp'),track=document.getElementById('hst'),prog=document.getElementById('hsp');
  if(!vp||!track||!prog)return;
  const cards=track.querySelectorAll('.hcard');
  const dots=prog.querySelectorAll('.hpp');
  if(!cards.length)return;
  const padLeft=parseFloat(getComputedStyle(track).paddingLeft)||0;
  function targetFor(i){ return Math.max(0,cards[i].offsetLeft-padLeft); }
  function syncDots(){
    const left=vp.scrollLeft;
    let nearest=0,best=Infinity;
    cards.forEach((c,i)=>{
      const d=Math.abs(targetFor(i)-left);
      if(d<best){best=d;nearest=i;}
    });
    dots.forEach((pp,i)=>pp.classList.toggle('active',i===nearest));
  }
  vp.addEventListener('scroll',syncDots,{passive:true});
  dots.forEach((pp,i)=>pp.addEventListener('click',()=>{
    vp.scrollTo({left:targetFor(i),behavior:'smooth'});
  }));
  syncDots();
}

// ─── ODOMETERS ───────────────────────────────────────
function initOdometers(){
  const configs=[{id:'od0',val:'50'},{id:'od1',val:'16'},{id:'od2',val:'5'},{id:'od3',val:'40'}];
  function buildOd(id,val){
    const w=document.getElementById(id);if(!w)return;
    w.innerHTML='';
    val.split('').forEach(ch=>{
      const col=document.createElement('div');col.className='od-col';
      for(let d=0;d<=9;d++){const s=document.createElement('span');s.textContent=d;col.appendChild(s);}
      w.appendChild(col);
      setTimeout(()=>{col.style.transform=`translateY(-${parseInt(ch)*1.25}em)`;},100);
    });
  }
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      e.target.classList.add('vis');
      const idx=Array.from(e.target.parentElement.children).indexOf(e.target);
      const cfg=configs[idx];if(cfg)buildOd(cfg.id,cfg.val);
      io.unobserve(e.target);
    });
  },{threshold:.3});
  document.querySelectorAll('.scell').forEach(el=>io.observe(el));
}

// ─── TERMINAL ────────────────────────────────────────
function initTerminal(){
  const lines=document.querySelectorAll('.tl');
  const tIO=new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting){lines.forEach((l,i)=>setTimeout(()=>l.classList.add('on'),i*105));tIO.disconnect();}
  },{threshold:.18});
  const tb=document.getElementById('termBody');if(tb)tIO.observe(tb);
  const rmIO=new IntersectionObserver(entries=>{
    if(entries.some(e=>e.isIntersecting)){document.querySelectorAll('.rmf').forEach(b=>{b.style.width=b.dataset.w;});rmIO.disconnect();}
  },{threshold:.2});
  const rm=document.querySelector('.rm');if(rm)rmIO.observe(rm);
}

// ─── BENTO STAGGER ───────────────────────────────────
function initBento(){
  const cards=document.querySelectorAll('.bcard');
  const io=new IntersectionObserver(entries=>{
    if(entries.some(e=>e.isIntersecting)){
      cards.forEach((c,i)=>setTimeout(()=>c.classList.add('vis'),i*65));
      io.disconnect();
    }
  },{threshold:.05});
  const g=document.querySelector('.bento-grid');if(g)io.observe(g);
}

// ─── REVEAL ──────────────────────────────────────────
function initReveal(){
  // Reveal everything synchronously. SSR puts the content in the DOM and the
  // CSS transition on `.rev`/`.tcard`/`.pcard`/`.step` still produces a fade,
  // we just no longer wait for an IntersectionObserver — which was the source
  // of "blank page until you scroll" bugs across prod builds and back-nav.
  document.querySelectorAll('.rev,.tcard,.pcard,.step').forEach(el=>el.classList.add('vis'));
  // stagger pricings
  const pIO=new IntersectionObserver(e=>{
    if(e.some(x=>x.isIntersecting)){document.querySelectorAll('.pcard').forEach((c,i)=>setTimeout(()=>c.classList.add('vis'),i*75));pIO.disconnect();}
  },{threshold:.04});
  const pg=document.getElementById('pgrid');if(pg)pIO.observe(pg);
  // stagger tcards
  const tIO=new IntersectionObserver(e=>{
    if(e.some(x=>x.isIntersecting)){document.querySelectorAll('.tcard').forEach((c,i)=>setTimeout(()=>c.classList.add('vis'),i*100));tIO.disconnect();}
  },{threshold:.04});
  const tg=document.querySelector('.tgrid');if(tg)tIO.observe(tg);
  // stagger steps
  const sIO=new IntersectionObserver(e=>{
    if(e.some(x=>x.isIntersecting)){document.querySelectorAll('.step').forEach((s,i)=>setTimeout(()=>s.classList.add('vis'),i*90));sIO.disconnect();}
  },{threshold:.04});
  const sl=document.querySelector('.steps');if(sl)sIO.observe(sl);
}

// ─── 3D TILT ─────────────────────────────────────────
function initTilt(){
  document.querySelectorAll('[data-tilt]').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      const r=card.getBoundingClientRect();
      const x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      card.style.transform=`perspective(800px) rotateY(${x*9}deg) rotateX(${-y*7}deg) translateY(-4px)`;
      card.style.transition='transform .05s';
    });
    card.addEventListener('mouseleave',()=>{
      card.style.transform='';
      card.style.transition='transform .6s cubic-bezier(.34,1.56,.64,1),opacity .6s,background .25s,box-shadow .3s';
    });
  });
}

// ─── MAGNETIC ────────────────────────────────────────
function initMagnetic(){
  document.querySelectorAll('[data-mag]').forEach(btn=>{
    btn.addEventListener('mousemove',e=>{
      const r=btn.getBoundingClientRect();
      btn.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.24}px,${(e.clientY-r.top-r.height/2)*.24}px)`;
    });
    btn.addEventListener('mouseleave',()=>{
      btn.style.transform='';btn.style.transition='transform .6s cubic-bezier(.34,1.56,.64,1)';
      setTimeout(()=>btn.style.transition='',650);
    });
  });
}

// ─── CTA CANVAS ──────────────────────────────────────
function initCtaCanvas(){
  const canvas=document.getElementById('ctaC');if(!canvas)return;
  const ctx=canvas.getContext('2d');let W,H;const P=[];
  const resize=()=>{W=canvas.width=canvas.offsetWidth;H=canvas.height=canvas.offsetHeight;};
  resize();window.addEventListener('resize',resize);
  let last=0;
  (function draw(t){
    ctx.clearRect(0,0,W,H);
    if(t-last>150){P.push({x:Math.random()*W,y:H+8,vx:(Math.random()-.5)*.65,vy:-(Math.random()*1.1+.5),r:Math.random()*1.8+.4,a:Math.random()*.35+.12,life:1});last=t;}
    for(let i=P.length-1;i>=0;i--){
      const p=P[i];p.x+=p.vx;p.y+=p.vy;p.life-=.005;
      if(p.life<=0||p.y<-10){P.splice(i,1);continue;}
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);ctx.fillStyle=`rgba(184,110,44,${p.a*p.life})`;ctx.fill();
    }
    requestAnimationFrame(draw);
  })(0);
}

// ─── PLATFORM IN MOTION PLAYER ───────────────────────
function initMotionPlayer(){
  // 9 s per scene = in-scene animation (~3.5–4 s parsing bar / scan beam /
  // score count-up) + ~5 s rest on the completed state so the viewer can
  // actually read the final numbers before the carousel advances.
  const SCENE_DUR=9000;
  let current=0,paused=false,timer=null;
  const scenes=document.querySelectorAll('.mscene');
  const tabs=document.querySelectorAll('.mtab');
  const dots=document.querySelectorAll('.mpd');
  const fill=document.getElementById('motionFill');
  const timeEl=document.getElementById('motionTime');
  const pauseBtn=document.getElementById('pauseBtn');
  const section=document.getElementById('motionSection');

  if(!scenes.length)return;

  function setScene(idx){
    // hide old
    scenes[current].classList.remove('active');
    tabs[current].classList.remove('active');
    dots[current].classList.remove('active');
    current=idx;
    scenes[current].classList.add('active');
    tabs[current].classList.add('active');
    dots[current].classList.add('active');
    if(timeEl)timeEl.textContent=String(idx+1).padStart(2,'0')+' / 05';
    resetFill();
    triggerSceneAnimations(idx);
  }

  function resetFill(){
    if(fill){
      fill.style.transition='none';
      fill.style.width='0';
      requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
          fill.style.transition=`width ${SCENE_DUR}ms linear`;
          fill.style.width='100%';
        });
      });
    }
  }

  function startTimer(){
    clearTimeout(timer);
    if(!paused){
      timer=setTimeout(()=>{
        const next=(current+1)%5;
        setScene(next);
        startTimer();
      },SCENE_DUR);
    }
  }

  window.goScene=function(idx){
    setScene(idx);
    startTimer();
  };
  window.prevScene=function(){goScene((current-1+5)%5);};
  window.nextScene=function(){goScene((current+1)%5);};
  window.togglePause=function(){
    paused=!paused;
    if(pauseBtn)pauseBtn.textContent=paused?'▶ Play':'⏸ Pause';
    if(pauseBtn)pauseBtn.classList.toggle('pause-active',paused);
    if(paused){
      clearTimeout(timer);
      if(fill){fill.style.transition='none';}
    } else {
      resetFill();startTimer();
    }
  };

  tabs.forEach((tab,i)=>tab.addEventListener('click',()=>goScene(i)));

  // pause on hover
  if(section){
    section.addEventListener('mouseenter',()=>{if(!paused){clearTimeout(timer);if(fill)fill.style.transition='none';}});
    section.addEventListener('mouseleave',()=>{if(!paused){resetFill();startTimer();}});
  }

  // Start when visible
  const mIO=new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting){triggerSceneAnimations(0);resetFill();startTimer();mIO.disconnect();}
  },{threshold:.2});
  if(section)mIO.observe(section);
}

function triggerSceneAnimations(idx){
  // Reset all scene internal state first
  resetAllSceneInternals();
  if(idx===0)animScene0();
  else if(idx===1)animScene1();
  else if(idx===2)animScene2();
  else if(idx===3)animScene3();
  else if(idx===4)animScene4();
}

function resetAllSceneInternals(){
  // Scene 0
  const uz=document.getElementById('uz');const uf=document.getElementById('uf');const uparse=document.getElementById('uparse');const upfill=document.getElementById('upfill');const upc=document.getElementById('upc');
  if(uz)uz.classList.remove('drag-in');
  if(uf)uf.classList.remove('show');
  if(uparse)uparse.classList.remove('show');
  if(upfill)upfill.style.width='0';if(upc)upc.textContent='0%';
  ['us1','us2','us3'].forEach(id=>document.getElementById(id)?.classList.remove('show'));
  // Scene 1
  ['sc1','sc2','sc3'].forEach(id=>{const el=document.getElementById(id);if(el){el.classList.remove('lit','lit-a');}});
  const sb=document.getElementById('scanBeamMV');if(sb){sb.classList.remove('active');void sb.offsetWidth;}
  const sn=document.getElementById('scanNum');if(sn)sn.textContent='0';
  // Scene 2
  const rs=document.getElementById('rdScore');if(rs)rs.textContent='0';
  const rss=document.getElementById('rdScoreStat');if(rss)rss.textContent='0';
  const arc=document.getElementById('rdArcFill');if(arc)arc.style.strokeDashoffset='201';
  document.querySelectorAll('.rd-bar-f').forEach(b=>{b.style.transition='none';b.style.width='0';});
  ['rdc1','rdc2','rri1','rri2','rri3'].forEach(id=>document.getElementById(id)?.classList.remove('show'));
  // Scene 3
  const rq=document.getElementById('researchQuery');if(rq)rq.textContent='';
  const rst=document.getElementById('researchStatus');if(rst)rst.textContent='Checking at the source…';
  ['rc1','rc2','rc3'].forEach(id=>document.getElementById(id)?.classList.remove('show'));
  // Scene 4
  ['rl1','rl2','rlStatus'].forEach(id=>document.getElementById(id)?.classList.remove('show'));
}

function animScene0(){
  const uz=document.getElementById('uz'),uf=document.getElementById('uf'),uparse=document.getElementById('uparse'),upfill=document.getElementById('upfill'),upc=document.getElementById('upc');
  setTimeout(()=>{if(uz)uz.classList.add('drag-in');},400);
  setTimeout(()=>{if(uf)uf.classList.add('show');if(uz)uz.classList.remove('drag-in');},900);
  setTimeout(()=>{
    if(uparse)uparse.classList.add('show');
    let pct=0;const t=setInterval(()=>{pct+=2;if(upfill)upfill.style.width=pct+'%';if(upc)upc.textContent=pct+'%';if(pct>=100)clearInterval(t);},40);
  },1400);
  setTimeout(()=>{document.getElementById('us1')?.classList.add('show');},2800);
  setTimeout(()=>{document.getElementById('us2')?.classList.add('show');},3100);
  setTimeout(()=>{document.getElementById('us3')?.classList.add('show');},3400);
}

function animScene1(){
  const sc1=document.getElementById('sc1'),sc2=document.getElementById('sc2'),sc3=document.getElementById('sc3');
  const sb=document.getElementById('scanBeamMV'),sn=document.getElementById('scanNum'),st=document.getElementById('scanCounterText');
  if(sb){void sb.offsetWidth;sb.classList.add('active');}
  let c=0;const ct=setInterval(()=>{c++;if(sn)sn.textContent=c;if(c>=47)clearInterval(ct);},80);
  setTimeout(()=>{if(sc1)sc1.classList.add('lit');if(st)st.textContent='§14 Indemnification — High Risk detected';},700);
  setTimeout(()=>{if(sc2)sc2.classList.add('lit-a');if(st)st.textContent='§8 IP Assignment — Review flagged';},1500);
  setTimeout(()=>{if(sc3)sc3.classList.add('lit-a');if(st)st.textContent='§21 Termination — Non-standard';},2300);
  setTimeout(()=>{if(st)st.textContent='Analysis complete · 3 issues found';},3100);
}

function animScene2(){
  const rscore=document.getElementById('rdScore'),rss=document.getElementById('rdScoreStat');
  const arc=document.getElementById('rdArcFill');
  setTimeout(()=>{
    document.getElementById('rdc1')?.classList.add('show');
    setTimeout(()=>{document.querySelectorAll('.rd-bar-f').forEach(b=>{b.style.transition='width 1.2s cubic-bezier(.76,0,.24,1)';b.style.width=b.dataset.w;});},200);
    let s=0;const t=setInterval(()=>{s+=2;if(rscore)rscore.textContent=s;if(rss)rss.textContent=s;if(arc)arc.style.strokeDashoffset=201-(201*s/100);if(s>=72)clearInterval(t);},28);
  },300);
  setTimeout(()=>{document.getElementById('rdc2')?.classList.add('show');},1200);
  setTimeout(()=>{document.getElementById('rri1')?.classList.add('show');},1500);
  setTimeout(()=>{document.getElementById('rri2')?.classList.add('show');},1900);
  setTimeout(()=>{document.getElementById('rri3')?.classList.add('show');},2300);
}

function animScene3(){
  const q=document.getElementById('researchQuery');
  // Scene 4 became a statute check on 2026-09-18 (PlatformInMotion.tsx) —
  // legal research is India-only and 404s here. Same ids, same reveal timing.
  const query='liability cap · processor terms · governing law: England & Wales';
  let i=0;const t=setInterval(()=>{if(q)q.textContent=query.slice(0,i);i++;if(i>query.length)clearInterval(t);},40);
  setTimeout(()=>{
    const rs=document.getElementById('researchStatus');
    if(rs)rs.textContent='3 provisions checked at the official source';
  },query.length*40+400);
  setTimeout(()=>{document.getElementById('rc1')?.classList.add('show');},query.length*40+700);
  setTimeout(()=>{document.getElementById('rc2')?.classList.add('show');},query.length*40+1100);
  setTimeout(()=>{document.getElementById('rc3')?.classList.add('show');},query.length*40+1500);
}

function animScene4(){
  setTimeout(()=>{document.getElementById('rl1')?.classList.add('show');},400);
  setTimeout(()=>{document.getElementById('rl2')?.classList.add('show');},1100);
  setTimeout(()=>{document.getElementById('rlStatus')?.classList.add('show');},2000);
}

// ─── INTERACTIVE ─────────────────────────────────────
function setP(btn,id){
  document.querySelectorAll('.ptab').forEach(t=>t.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.pcp').forEach(p=>p.classList.remove('active'));
  const panel=document.getElementById('p-'+id);
  if(panel)panel.classList.add('active');
}
function filterP2(btn,group){
  document.querySelectorAll('.tgl').forEach(t=>t.classList.remove('active'));
  btn.classList.add('active');
  const map={all:['individual','professional','team'],individual:['individual'],professional:['professional'],team:['team']};
  const show=map[group]||['individual'];
  document.querySelectorAll('.pcard').forEach(c=>{
    c.style.display=show.includes(c.dataset.pt||'individual')?'block':'none';
  });
}
// expose scene nav globally (used by onclick in HTML)
window.goScene=window.goScene||function(){};
window.prevScene=window.prevScene||function(){};
window.nextScene=window.nextScene||function(){};

    // Expose functions globally so Sections.tsx can call them

// ─── SECTION LINE REVEAL ─────────────────────────────
function initSectionLines(){
  const sIO=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis-line');sIO.unobserve(e.target);}});
  },{threshold:.1});
  document.querySelectorAll('.bento-section,.testi-sec,.persona-sec').forEach(el=>sIO.observe(el));
}

// ─── PARALLAX ON MOUSE MOVE ──────────────────────────
function initParallax(){
  document.addEventListener('mousemove',e=>{
    const x=(e.clientX/window.innerWidth-.5)*2;
    const y=(e.clientY/window.innerHeight-.5)*2;
    document.querySelectorAll('.motion-orb').forEach((orb,i)=>{
      const speed=i===0?15:10;
      orb.style.transform=`translate(${x*speed}px,${y*speed}px)`;
    });
    document.querySelectorAll('.cta-ring').forEach((ring,i)=>{
      const speed=(i+1)*3;
      ring.style.transform=`translate(calc(-50% + ${x*speed}px),calc(-50% + ${y*speed}px))`;
    });
  });
}

// ─── DIFFERENTIATORS — IN-VIEW + LETTER CASCADE + MAGNETIC ─
function initDiffInView(){
  const rows=document.querySelectorAll('.diff-row');
  if(!rows.length)return;
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('in-view');
        io.unobserve(e.target);
      }
    });
  },{threshold:.22});
  rows.forEach(r=>io.observe(r));
}

function initEmLetters(){
  document.querySelectorAll<HTMLElement>('.em-glow[data-letters]').forEach(el=>{
    if(el.dataset.split==='1')return;
    const text=el.dataset.letters||'';
    const baseDelay=parseFloat(el.style.animationDelay||'0')||0;
    el.innerHTML=text.split('').map((ch,j)=>{
      const d=(baseDelay+0.5+j*0.04).toFixed(3);
      const safe=ch===' '?'&nbsp;':ch.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      return `<span class="dhl" style="animation-delay:${d}s">${safe}</span>`;
    }).join('');
    el.dataset.split='1';
  });
}

function initDiffMagnetic(){
  const els=document.querySelectorAll<HTMLElement>('.diff-action, .dviz-card, .dmv-item');
  els.forEach(el=>{
    el.addEventListener('mousemove',(e:MouseEvent)=>{
      const r=el.getBoundingClientRect();
      const x=((e.clientX-r.left)/r.width-0.5)*6;
      const y=((e.clientY-r.top)/r.height-0.5)*6;
      el.style.setProperty('--mx',`${x}px`);
      el.style.setProperty('--my',`${y}px`);
    });
    el.addEventListener('mouseleave',()=>{
      el.style.setProperty('--mx','0px');
      el.style.setProperty('--my','0px');
    });
  });
}

// ─── DVIZ NUMBER COUNT-UP ─────────────────────────────
function initDvizCounters(){
  const els=document.querySelectorAll('.dviz-num[data-target]');
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const el=e.target as HTMLElement;
      const target=parseInt(el.dataset.target||'0',10);
      if(isNaN(target)||target<=0){io.unobserve(el);return;}
      const dur=1400;const start=performance.now();
      function tick(now:number){
        const p=Math.min((now-start)/dur,1);
        const ease=1-Math.pow(1-p,4);
        el.textContent=Math.round(ease*target).toLocaleString('en-US');
        if(p<1)requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  },{threshold:.4});
  els.forEach(el=>io.observe(el));
}

// ─── SMOOTH COUNTER ANIMATION ────────────────────────
function initSmoothCounters(){
  const counters=document.querySelectorAll('.bcard-stat');
  const cIO=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const el=e.target;
      const text=el.textContent;
      const num=parseInt(text.replace(/[^0-9]/g,''));
      if(isNaN(num))return;
      const suffix=text.replace(/[0-9]/g,'');
      let cur=0;const dur=1500;const start=performance.now();
      function tick(now){
        const p=Math.min((now-start)/dur,1);
        const ease=1-Math.pow(1-p,4);
        cur=Math.round(ease*num);
        el.textContent=cur.toLocaleString('en-US')+suffix;
        if(p<1)requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      cIO.unobserve(el);
    });
  },{threshold:.5});
  counters.forEach(el=>cIO.observe(el));
}

// ─── STAGGER FOOTER COLUMNS ─────────────────────────
function initFooterReveal(){
  const fIO=new IntersectionObserver(entries=>{
    if(entries.some(e=>e.isIntersecting)){
      document.querySelectorAll('.fg > div').forEach((col,i)=>{
        col.style.opacity='0';
        col.style.transform='translateY(16px)';
        col.style.transition=`opacity .5s ${i*0.08}s cubic-bezier(0,0,.2,1),transform .5s ${i*0.08}s cubic-bezier(0,0,.2,1)`;
        setTimeout(()=>{col.style.opacity='1';col.style.transform='none';},50);
      });
      fIO.disconnect();
    }
  },{threshold:.1});
  const fg=document.querySelector('.fg');
  if(fg)fIO.observe(fg);
}

// ─── SMOOTH SCROLL SNAP INDICATOR ───────────────────
function initScrollSnap(){
  let ticking=false;
  window.addEventListener('scroll',()=>{
    if(!ticking){
      requestAnimationFrame(()=>{
        const sections=document.querySelectorAll('section,.diff-section,.stats-sec,.how-sec');
        sections.forEach(sec=>{
          const rect=sec.getBoundingClientRect();
          const visible=rect.top<window.innerHeight*.8&&rect.bottom>0;
          if(visible){
            sec.style.opacity='1';
            sec.style.transform='none';
          }
        });
        ticking=false;
      });
      ticking=true;
    }
  },{passive:true});
}
    (window as any).initCanvas = initCanvas;
    (window as any).initDemo = initDemo;
    (window as any).initMarquee = initMarquee;
    (window as any).initHScroll = initHScroll;
    (window as any).initStickyStory = initStickyStory;
    (window as any).initEngines = initEngines;
    (window as any).initOdometers = initOdometers;
    (window as any).initTerminal = initTerminal;
    (window as any).initReveal = initReveal;
    (window as any).initBento = initBento;
    (window as any).initTilt = initTilt;
    (window as any).initMagnetic = initMagnetic;
    (window as any).initCtaCanvas = initCtaCanvas;
    (window as any).initNav = initNav;
    (window as any).initScramble = initScramble;
    (window as any).initMotionPlayer = initMotionPlayer;
    (window as any).initSectionLines = initSectionLines;
    (window as any).initParallax = initParallax;
    (window as any).initSmoothCounters = initSmoothCounters;
    (window as any).initDvizCounters = initDvizCounters;
    (window as any).initDiffInView = initDiffInView;
    (window as any).initEmLetters = initEmLetters;
    (window as any).initDiffMagnetic = initDiffMagnetic;
    (window as any).initFooterReveal = initFooterReveal;
    (window as any).initScrollSnap = initScrollSnap;
    (window as any).setP = setP;
    (window as any).filterP2 = filterP2;
    (window as any).goScene = (window as any).goScene || function(){};
    (window as any).prevScene = (window as any).prevScene || function(){};
    (window as any).nextScene = (window as any).nextScene || function(){};
    (window as any).togglePause = (window as any).togglePause || function(){};

    // Respect prefers-reduced-motion: skip motion-heavy initialisers (parallax,
    // tilt, magnetic, marquee, scramble, canvas scenes). Keep
    // structural/reveal/nav inits so layout still works without animation.
    const reduce = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const motionInits = [
      // initCursor (the custom dot + ring cursor) was removed on 2026-09-15
      // at the owner's request — the site uses the native OS cursor.
      initCanvas, initMarquee,
      initStickyStory, initTerminal, initEngines,
      initTilt, initMagnetic, initCtaCanvas, initScramble,
      initMotionPlayer, initParallax, initSmoothCounters,
      initEmLetters, initDvizCounters, initDiffMagnetic,
    ];
    const structuralInits = [
      // initDemo is content, not decoration — the hero demo's score,
      // bars, risk tags, fix, and cited authorities are essential to
      // the page's value prop. Must run even with prefers-reduced-motion.
      initDemo,
      initHScroll, initOdometers, initReveal, initBento, initNav,
      initSectionLines, initDiffInView, initFooterReveal, initScrollSnap,
    ];
    const inits = reduce ? structuralInits : [...motionInits, ...structuralInits];
    for (const fn of inits) {
      try { fn(); } catch (e) { console.error('[ClientScripts] init failed:', fn.name, e); }
    }

    // On bfcache restore (browser back/forward where the page is served
    // from memory), useEffect does NOT re-run. Re-trigger the hero demo so
    // the score, bars, risk tags, fix, and cited authorities animate in
    // again — they're essential content, not decoration.
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        try { initDemo(); } catch (err) { console.error('[ClientScripts] initDemo replay failed:', err); }
      }
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  return null;
}
